import Client from "./Client";
import User from "Class/User";
import { AnyObject } from "types";

export class LoginService {
  public static async signIn(email: string, password: string): Promise<void> {
    const { data } = await Client.post("/auth", {
      email,
      password,
      client: "web",
    });
    const currentUser = new User(data.data.user);
    currentUser.token = data.data.token;
    localStorage.setItem("currentUser", JSON.stringify(currentUser));
  }
  public static async signOut(dataRegister: AnyObject): Promise<void> {
    await Client.post("/register", dataRegister);
  }

  public static isAuthenticated(): boolean {
    const auth = !!localStorage.getItem("currentUser");
    return auth;
  }

  public static currentUser(): User | null {
    const auth = localStorage.getItem("currentUser");
    if (auth) {
      return new User(JSON.parse(auth));
    }
    return null;
  }

  public static token(): string | null {
    const auth = localStorage.getItem("currentUser");
    if (auth) {
      const currentUser = JSON.parse(auth);
      return currentUser.token;
    }
    return null;
  }

  public static logout(): void {
    localStorage.removeItem("currentUser");
  }
}
